import { useEffect, useState } from "react";

import { useWindowOpen } from "../hooks/useWindowOpen";
import { useWindowCommunication } from "../hooks/useWindowCommunication";

const ClosedMessage = "closed";

interface IuseWindowCommunicationProvider {
  closed: boolean,
  open: () => void
}

export function useWindowCommunicationProvider(url: string, name: string): IuseWindowCommunicationProvider {
  const [closed, setClosed] = useState(false);
  const windowOpen = useWindowOpen();
  const [communication] = useWindowCommunication(name);

  useEffect(() => {
    const closed = communication.current === ClosedMessage;

    if (!closed || !windowOpen.opened) {
      return;
    }

    windowOpen.opened.current?.close();

    setClosed(true);
  }, [communication]);


  return {
    closed,
    open() {
      windowOpen.open(url);
    }
  };
}

interface IuseWindowCommunicationConsumer {
  close: () => void;
}

export function useWindowCommunicationConsumer(name: string): IuseWindowCommunicationConsumer {
  const [, integrationInstallationPostMessage] = useWindowCommunication(name);

  return {
    close() {
      integrationInstallationPostMessage(ClosedMessage);
    }
  };
}
